// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lead-collector-section{margin-bottom:var(--unit-0100);margin-top:var(--unit-0800);padding:var(--unit-0600);width:100%}@media(min-width:992px){.lead-collector-section{min-width:248px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
